import React from "react";
import { Table, Button } from "react-bootstrap";
import { del } from "../../../../helpers/api_helper";
import toast from "react-hot-toast";
import action_icon_1 from "../../../../Assets/svg/tableData/action-icon-1.svg";
import action_icon_2 from "../../../../Assets/svg/tableData/action-icon-2.svg";
import useCheckPermission from "../../../../hooks/useCheckPermission";

const TableData = ({ data, onEdit, refresh }) => {
  const handleDelete = async (id) => {
    try {
      await del(`/admin/heliocentric-config/${id}`);
      toast.success("Config deleted successfully");
      refresh();
    } catch (err) {
      toast.error("Delete failed");
    }
  };

    const hasUpdatePermission = useCheckPermission("user", "UPDATE");
    const hasDeletePermission = useCheckPermission("user", "DELETE");

  return (
    <Table bordered responsive>
      <thead>
        <tr>
          <th>Master Planet</th>
          <th>Secondary Planet</th>
          <th>Aspect</th>
          <th>Direction</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {data?.length ? (
          data.map((item) => (
            <tr key={item._id}>
              <td>{item.masterPlanet}</td>
              <td>{item.secondaryPlanet}</td>
              <td>{item.aspectDegree === 999 ? "No Aspect" : item.aspectDegree}</td>
              <td>{item.direction}</td>
              <td>{item.status}</td>
              <td>
                <div className="d-flex align-items-center gap-10">
                  {hasUpdatePermission && <Button
                    className="border-0 p-0"
                    variant="transparent"
                    onClick={() => onEdit(item)}
                  >
                    <img src={action_icon_1} alt="" />
                  </Button>}
                  {hasDeletePermission && <Button
                    className="border-0 p-0"
                    variant="transparent"
                    onClick={() => handleDelete(item._id)}
                  >
                    <img src={action_icon_2} alt="" />
                  </Button>}
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6">No Data</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default TableData;